// 油品调整
import { request,pretty } from '@/utils/request' 
export const addNotice = (item)=>{
  return pretty(request.post("/api/Notice/Add",{...item}));
}
export const deleteNotice = (item)=>{
  return pretty(request.post(`/api/Notice/Delete?ids=${item}`));
}
export const detailNotice = (item)=>{
  return pretty(request.get(`/api/Notice/Detail?id=${item}`));
}
export const editNotice = (item)=>{
  return pretty(request.post("/api/Notice/Edit",{...item}));
}
export const listNotice = (item)=>{
  return pretty(request.get(`/api/Notice/List?title=${item?.title?(item?.title):''}&pageSize=${item?.pageSize?(item?.pageSize):10}&pageIndex=${item?.pageIndex?(item?.pageIndex):1}`));
}

export const categoryNotice = ()=>{
  return pretty(request.post("/api/Notice/Category"));
}